define('Components/Jobs/js/views/JobsPageView',[
    'jquery',
    'underscore',
    'backbone',
    'PageView',
    'app',
    'SelectView',
    'router',
    'InputPhoneView'
], function ($, _, Backbone, PageView, app, SelectView, router, InputPhoneView) {

    var JobModalView = Backbone.View.extend({
        className:'job-modal',
        events:{
            'click .btn-close':'close'
        },
       initialize:function(content){
           var view = this;
           view.$el.append(
               '<button class="btn-close"><span></span><span></span></button><div class="wrapper">'+
               content+'</div>'
           );
           console.log(content)
           app.displayModal(view);
       },
        close:function(){
            this.trigger('close',this);
        }
    });

    return PageView.extend({
        pageName:'Jobs',
        events:{
            'click .job-list li': 'toggleJobDescription',
            'submit #job-form': 'jobform',
        },

        jobform: function (e) {


            var view = this;
            e.preventDefault();
            var lastname = view.$('input[name=lastname]').val(),
                firstname = view.$('input[name=firstname]').val(),
                address = view.$('input[name=address]').val(),
                postcode = view.$('input[name=postcode]').val(),
                city = view.$('input[name=city]').val(),
                country = view.$('input[name=country]').val(),
                email = view.$('input[name=email]').val(),
                phone = view.$('input[name=phone]').val(),
                message = view.$('textarea[name=message]').val(),
                job = view.$('select[name=job]').val();

            if (
                lastname == '' || firstname == '' || address == '' || postcode == '' || city == '' || email == '' || message == '') {
                app.banNotice(t('Des champs obligatoires sont manuants'));
                return;
            }
            var urlOptions = {};
            _.extend(urlOptions,{iso_lang:app.isoLang()});
            var url = router.getApiRouteUrl('apiJob')(urlOptions);


            var dataImage = new FormData;
            dataImage.append('image', $('input[type=file]')[0].files[0]);



                view.$('#job-form button').addClass('loading');
                view.$('#job-form button').prop('disabled', true);


            $.ajax({
                url: url + '?upload=true',
                method: 'POST',
                contentType: false, // obligatoire pour de l'upload
                processData: false, // obligatoire pour de l'upload
                dataType: 'json', // what type of data do we expect back from the server
                data: dataImage,
            }).done(function (response) {

                var file_name = response.file_name;

                $.ajax({
                    url: url,
                    method: 'POST',
                    data:      {
                        lastname:lastname,
                        firstname:firstname,
                        address:address,
                        postcode:postcode,
                        city:city,
                        file_name:file_name,
                        email:email,
                        phone:phone,
                        country:country,
                        message:message,
                        job:job,
                    }
                }).done(function (data) {
                    app.bottomNotice(app.t('Demande envoyée', 'Jobs'));
                    app.trigger('contactSuccessReset')
                }).fail(function (response) {
                    app.bottomNotice(response.responseJSON.error);
                    app.trigger('contactFailReset')
                });


            }).fail(function (response) {
                var message,responseJSON,supported_extensions;
                if ((responseJSON=response.responseJSON) && (message = responseJSON.error)) {
                    if(responseJSON.data && (supported_extensions = responseJSON.data.supported_extensions)){
                        message += ' '+app.t('Les extensions supportées sont %s.','Upload',supported_extensions.join(','));
                    }
                    app.banNotice(message);
                } else {
                    app.alert();
                }
                app.trigger('contactFailReset')
            });
        },

        contactSuccessReset:function () {
            var view = this;

            view.$('#job-form')[0].reset();

            view.$('#job-form button').removeClass('loading');
            view.$('#job-form button').prop('disabled', false);

        },
        contactFailReset:function () {
            var view = this;



            view.$('#job-form button').removeClass('loading');
            view.$('#job-form button').prop('disabled', false);

        },
        initialize:function(){

            var view = this,
                jobsMessage = view.$('[name="jobs_message"]').val();
            view.listenTo(app, 'contactFailReset', view.contactFailReset);
            view.listenTo(app, 'contactSuccessReset', view.contactSuccessReset);
            // PageView constructor heritage
            PageView.prototype.initialize.apply(this,arguments);

            SelectView.initializeSelectsOfView(view);
            view.attachViews(InputPhoneView.initializeInputsOfView(view));

        },

        toggleJobDescription: function (e) {
            new JobModalView(this.$(e.currentTarget).html())
            //var view = this,
            //    $liContent = ,
            //    //$modalContent = $('<button class="btn-close"></button><div class="recrutement-modal">'+$liContent+'</div>'),
            //    modalView = ;
            ////modalView.$el.append($modalContent);
            //console.log('toggleJobDescription',$liContent);
            //view.$('.job-list li').removeClass('active');
            //view.$(e.currentTarget).addClass('active');
        }

    });
});
